Router
Handler:<b> {{ base?.handler }} </b>
Active: <b> {{ base?.rest }} </b>
User:  <b>  {{ token?.auth }} </b>
